<app-elevation-section [title]="languageService.LNG('Label.Expense')">
    <div class="grid-totals-wrapper">
        <dx-select-box
          [dataSource]="expenseTypes"
          displayExpr="Code"
          searchExpr="Code"
          valueExpr="ExpenseTypeId"
          [searchEnabled]="true"
          [showClearButton]="true"
          [(value)]="newExpense.ExpenseTypeId"
          [readOnly]="isEditingDisabled"
          placeholder="{{languageService.LNG('Label.Expense')}}">
        </dx-select-box>
        <dx-text-box placeholder="{{languageService.LNG('Label.Value')}}" 
          [(value)]="newExpense.Value" 
          [readOnly]="isEditingDisabled"
          (onEnterKey)="createNewExpense()">
        </dx-text-box>
    </div>
    <dx-data-grid #datagriddx [dataSource]="gridDataSource"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [height]="225"
                style="padding-bottom: 10px;"
                (onRowUpdating)="onRowUpdating($event)"
                (onEditorPreparing)="onEditorPreparing($event)"
                (onRowRemoving)="onRowRemoving($event)">
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-editing mode="cell"
                    [allowUpdating]="!isEditingDisabled"
                    [allowAdding]="false"
                    [allowDeleting]="!isEditingDisabled"
                    [useIcons]="true">
        </dxo-editing>
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-scrolling mode="virtual"></dxo-scrolling>

        <dxi-column dataField="ExpenseTypeId" caption="{{languageService.LNG('Label.Expense')}}" [setCellValue]="setExpenseTypeValue"
                    cellTemplate="expenseTypeCellTemplate" editCellTemplate="expenseTypeEditCellTemplate" ></dxi-column>
        <dxi-column dataField="Value" caption="{{languageService.LNG('Label.Value')}}" [width]="75" ></dxi-column>
        <dxi-column dataField="UnitCode" [allowEditing]="false" caption="" [width]="50" ></dxi-column>
        <div *dxTemplate="let data of 'expenseTypeCellTemplate'">
            {{data.data.Code}}
        </div>
        <div *dxTemplate="let data of 'expenseTypeEditCellTemplate'">
                <dx-select-box [dataSource]="expenseTypeDataSource"
                            displayExpr="Code"
                            searchExpr="Code"
                            [grouped]="true"
                            valueExpr="ExpenseTypeId"
                            (onValueChanged)="onExpenseTypeChanged($event, data)"
                            [value]="data.data.ExpenseTypeId">
                </dx-select-box>
        </div>
        <div *dxTemplate="let data of 'headerTitle'">
            <span style="font-size: 20px;" >{{this.languageService.LNG("Label.Expense")}}</span>
        </div>
    </dx-data-grid>
</app-elevation-section>
